export default function MuffinIcon({ filled }) {
    return (
        <svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true">
            <path
                d="M5.8 12.2 C4.2 7.2 7.6 3.8 12 3.8 C16.4 3.8 19.8 7.2 18.2 12.2 Z"
                fill={filled ? "#c9884a" : "none"}
                stroke={filled ? "#a06a35" : "rgba(138,104,60,0.45)"}
                strokeWidth="1.4"
            />
            <path
                d="M5.5 12.2 H18.5 L17 20.6 H7 Z"
                fill={filled ? "#2a7f7f" : "none"}
                stroke={filled ? "#1c5b5b" : "rgba(138,104,60,0.45)"}
                strokeWidth="1.4"
            />
        </svg>
    );
}
